import React, { useState, useEffect } from "react";
import Filters from "./Filters.js";
import Tiles from "./Tiles.js";
import { Section } from "@dc/react-components";
import { Spring } from "@dc/react-components";
import PropTypes from "prop-types";
import { Svg } from "../../../ws10";
import { useHistory } from "react-router-dom";

function FilterTiles({ tilesData }) {
  const [selectedFilter, setSelectedFilter] = useState("Phones");
  const [filteredData, setFilteredData] = useState(tilesData);
  const toggleFilterHandler = (selected) => {
    setSelectedFilter(selected);
  };
  const filterData = () => {
    const filtered = tilesData.filter((item) => item.category === selectedFilter);
    setFilteredData(filtered);
  };
  useEffect(() => {
    filterData();
  }, [selectedFilter]);

  const filterButtons = [
    {
      buttonClassName:
        selectedFilter === "Phones"
          ? "filter-tiles__option--button filter-tiles__option--button--active"
          : "filter-tiles__option--button",
      iconClassName: "icon--extra-small chevron__icon",
      iconSrc: Svg.Mobile,
      text: "Phones",
      textContainerClassName: "filter-tiles__button--text",
      onClickHandler: toggleFilterHandler
    },
    {
      buttonClassName:
        selectedFilter === "Plans"
          ? "filter-tiles__option--button filter-tiles__option--button--active"
          : "filter-tiles__option--button",
      iconClassName: "icon--extra-small chevron__icon",
      iconSrc: Svg.Bundles,
      text: "Plans",
      textContainerClassName: "filter-tiles__button--text",
      onClickHandler: toggleFilterHandler
    },
    {
      buttonClassName:
        selectedFilter === "Broadband"
          ? "filter-tiles__option--button filter-tiles__option--button--active"
          : "filter-tiles__option--button",
      iconClassName: "icon--extra-small chevron__icon",
      iconSrc: Svg.Broadband,
      text: "Broadband",
      textContainerClassName: "filter-tiles__button--text",
      onClickHandler: toggleFilterHandler
    }
  ];
  const history = useHistory();
  return (
    <Section color="wild-sand">
      <Spring className="filter-tiles">
        <div className="filter-tiles__header">
          <h3 className="heading heading--4 section__title">Most popular</h3>
          {history.location.pathname === "/" && <a className="filter-tiles__header--link">View all</a>}
        </div>
        <Filters selectedFilter={selectedFilter} filters={filterButtons} />
        <Tiles tiles={filteredData} />
      </Spring>
    </Section>
  );
}

FilterTiles.propTypes = {
  filterButtons: PropTypes.array.isRequired,
  tilesData: PropTypes.array.isRequired
};

export default FilterTiles;
